











































import 'firebase/messaging'
import userModule from './store/user'
import { Component, Vue } from 'vue-property-decorator'
import { getToken } from 'firebase/messaging'
import { messaging } from '@/plugins/firebase'

@Component({
  name: 'App'
})
export default class App extends Vue {
  private showCookieBanner = false
  private links = [
    { title: 'Impressum', href: 'https://www.muensterland.de/impressum' },
    { title: 'AGB', href: 'https://legal.muensterland.de/agb/' },
    {
      title: 'Nutzungsbedingungen',
      href: 'https://legal.muensterland.de/nutzungsbedingungen/'
    },
    { title: 'Datenschutz', href: 'https://www.muensterland.de/privacy' },
    { title: 'FAQ', href: 'https://legal.muensterland.de/faq/' },
    { title: 'Presse', href: 'https://legal.muensterland.de/presse/' },
    { title: 'Jobs', href: 'https://legal.muensterland.de/jobs/' }
  ]

  private setCookieConsent(accepted: boolean): void {
    this.showCookieBanner = false
    localStorage.setItem('cookie-consent', accepted ? 'accepted' : 'rejected')
    if (accepted) {
      this.loadMessaging()
    }
  }

  private async loadMessaging(): Promise<void> {
    const webPushToken = await getToken(messaging)
    userModule.updateWebPushToken(webPushToken)
  }

  private mounted() {
    const consent = localStorage.getItem('cookie-consent')
    this.showCookieBanner = consent === null
    if (consent === 'accepted') {
      this.loadMessaging()
    }
  }
}
